export enum PropertyCommercialOnlyFeaturesEnum {
  CANTEEN = 'CANTEEN',
  LAN_CABLES = 'LAN_CABLES',
  HIGH_VOLTAGE = 'HIGH_VOLTAGE',
  AIR_CONDITIONING = 'AIR_CONDITIONING'
}
